import { Arguments, FunctionDefinition, SimpleFunctionDefinitionBase, ExpressionCompiler, AsyncExpressionCompiler } from "./expression.compiler";
import {
    LunaCodeNode, ArgumentNode, ArithmeticNode, BooleanLiteral, BooleanLogicNode,
    CaseNode, DateLiteral, NumberLiteral,
    FunctionNode, IfNode, InNode, IsNullNode,
    LikeNode, NotNode, NullLiteral, StringLiteral, VariableNode, WhenNode, NodeKind
}
    from "../models/rules.model";
import { DateService } from "./date.service";
import { DomainDefinitionService } from  "../../builder/services/domain-definition.service";

export class Coalesce extends SimpleFunctionDefinitionBase {
    name: string = "COALESCE";
    constructor() { super(); }

    invoke(a: Arguments, args: (arg: Arguments) => any[]) : any {
        let params = args(a) as any[];
        let result: any = null;
        let counter = 0;
        while (counter < params.length && result == null) {
            if (params[counter] != null) result = params[counter];
            counter += 1;
        }
        return result;
    }
}

export class StringReplace extends SimpleFunctionDefinitionBase {
    name: string = "REPLACE";
    constructor() { super(); }

    invoke(a: Arguments, args: (arg: Arguments) => any[]): string {
        let params = args(a) as string[];
        if (params.length === 0) return "";
        if (params.length < 3) return (params[0] != null) ? params[0].toString() : "";
        let origin = params[0];
        let toReplace = params[1];
        let replacement = params[2];
        if (toReplace == null || toReplace.length === 0 || replacement === null || replacement.length === 0) return params[0] != null ? params[0].toString() : "";
        return origin.replace(toReplace, replacement).trim();
    }
}

export class GetDomain extends SimpleFunctionDefinitionBase{

    name:string = "GetDomain";
    constructor(public domainService: DomainDefinitionService){
        super();
    }
    invokeAsync(a:Arguments, args: (arg: Arguments) => Promise<Array<any>>): Promise<any>{
        return args(a).then(p=>{
            let domainId = p[0];
            return this.domainService.get(domainId)
            .toPromise()
            .then(d=>d.values);
        });
    }
    invoke(a: Arguments, args: (arg: Arguments) => any[]){
        const vals = args(a) as any[];
        const domainId = vals[0];
        throw new Error("Cant call GetDomain in a sync context");

        // let foo = null;
        // (async ()=>{
        //     const domain = await this.domainService.get(domainId).toPromise();
        //     foo = domain.values;
        // })();
        // return foo;
    }
}
export class GetProperty extends SimpleFunctionDefinitionBase {
    constructor() {
        super();
    }
    name: string = "GET_PROPERTY";
    invoke(a: Arguments, args: (arg: Arguments) => any[]) {
		let vals = args(a) as any[];
		if (vals == null || vals.length < 2 || vals[0] == null) return "";
		return vals[0][vals[1]];        
    }

}
export class ArrayContains extends SimpleFunctionDefinitionBase {
    constructor() {
        super();
    }
    name: string = "ARRAY_CONTAINS";
    invoke(a: Arguments, args: (arg: Arguments) => any[]) {
        var params = args(a) as any[];
        let contextValue = params[0];
        let value = params[1];

        return contextValue.indexOf(value) > -1;
    }

}
export class RegexMatch extends SimpleFunctionDefinitionBase {
    constructor(){
        super();
    }
    name: string = "RegexMatch";
    invoke(a: Arguments, args: (arg: Arguments) => any[]) {
        let parts = args(a);
        return (new RegExp(parts[1] as string).test(parts[0] as string));
    }

}
export class FormatDate extends SimpleFunctionDefinitionBase{
    name: string = "FormatDate";
    invoke(a: Arguments, args: (arg: Arguments) => any[]) {
        const x = args(a)[0];
        const dt = DateService.coerceDate(x);
        return DateService.formatDate(dt);
    }


}

export class ParseFloat extends SimpleFunctionDefinitionBase {
    constructor() {
        super();
    }
    name: string = "ParseFloat";
    invoke(a: Arguments, args: (arg: Arguments) => any[]) {
        const value = args(a)[0];
        if (value == null) return 0;
        const stringValue = new String(value);
        const result = parseFloat(stringValue.replace(/,/gi, ''));
        if (isNaN(result)) {
            return 0;
        }
        return result;
    };


}
export class DateAdd extends SimpleFunctionDefinitionBase{

    constructor(){ super(); }
    name:string = "DateAdd";
    invoke(a: Arguments, args: (arg: Arguments) => any[]) {

        let parts = args(a);
        let unit = (parts[0] ||"").toString().toLowerCase();
        let amount = parts[1];

        let date:Date = DateService.coerceDate(parts[2]);
        return DateService.dateAdd(unit, amount, date);
    };

}

export class DateDiff extends SimpleFunctionDefinitionBase{

    constructor(){ super(); }
    name:string = "DateDiff";
    invoke(a: Arguments, args: (arg: Arguments) => any[]) {
        let parts = args(a);
        let date1 = DateService.coerceDate(parts[0]);
        let date2 = DateService.coerceDate(parts[1]);
        let unit = parts[2];
        return DateService.dateDiff(unit, date1, date2);

    };

}
export class Now extends SimpleFunctionDefinitionBase{

    constructor(){ super(); }
    name:string = "NOW";
    invoke(a: Arguments, args: (arg: Arguments) => any[]) {
        return DateService.now();

    };

}

export class DatePart extends SimpleFunctionDefinitionBase{

    constructor(){ super(); }
    name:string = "DatePart";
    invoke(a: Arguments, args: (arg: Arguments) => any[]) {
        let parts = args(a);
        let date1 = DateService.coerceDate(parts[0]);
        let part = (parts[1] || "").toString();
        return DateService.datePart(part, date1);
    };

}


export class Today extends SimpleFunctionDefinitionBase{

    constructor(){ super(); }
    name:string = "TODAY";
    invoke(a: Arguments, args: (arg: Arguments) => any[]) {
        return DateService.today();

    };

}

export class ArrayOf extends SimpleFunctionDefinitionBase{
    constructor(){ super(); }
    name:string = "ArrayOf";
    invoke(a: Arguments, args: (arg: Arguments) => any[]) {
        return (args(a) != null) ? args(a).filter(i => i != null && i.toString() != null && i.toString().length > 0) : [];
    };
}
export class Filter implements FunctionDefinition{

    name:string = "Filter";

    compileSync(compiler: ExpressionCompiler, funcNode: FunctionNode): (args: Arguments) => any {
        let {array, lambdaArgument, lambdaExpression} = this._decomposeNodes(funcNode);
        let arr = compiler.compile(array);
        var expr = compiler.compile(lambdaExpression);
        return(args:Arguments)=>{
            let theArray:any[] = arr(args) as any[];
            let result = [];
            if(!theArray) return result;
            for(let i = 0; i< theArray.length; i++){
                let copy = this._cloneArguments(args);
                copy.args.set(lambdaArgument.name, theArray[i]);
                let itemResult = expr(copy);
                if(itemResult){
                    result.push(theArray[i]);
                }
            }
            return result;
        };
    }

    compileAsync(compiler: AsyncExpressionCompiler, funcNode:FunctionNode): (args: Arguments) => Promise<any> {
        let {array, lambdaArgument, lambdaExpression} = this._decomposeNodes(funcNode);
        let arr = compiler.compile(array);
        var expr = compiler.compile(lambdaExpression);
        return (args:Arguments)=>{
            return arr(args).then(theArray=>{
                let copies = (theArray as any[]).map(e=>{
                    var c = this._cloneArguments(args);
                    c.args.set(lambdaArgument.name, e);
                    return {element:e, localArgs:c};
                });
                var promises = copies.map(ee=>{
                    return expr(ee.localArgs).then(evaluated=>{ return {evaluated: evaluated, item: ee.element}});
                });
                return Promise.all(promises).then(evaluations=> evaluations.filter(qq=>qq.evaluated).map(qq=>qq.item));
            });
        }
    }

    public _cloneArguments(args:Arguments) : Arguments{
        let map = new Map<string,any>();
        for(let k of Array.from(args.args.keys()))
        {
            map.set(k, args.args.get(k));
        }
        return {context: args.context, args:map};

    }
    public _decomposeNodes(funcNode:FunctionNode) : {array:LunaCodeNode, lambdaArgument:ArgumentNode, lambdaExpression: LunaCodeNode }{
        if(funcNode.parameterList.length !== 2 || !funcNode.parameterList[1]){
            throw new Error("filter requires two parametrs the first is an array, the second is a conditional expression");
        }
        if(funcNode.parameterList[1].nodeType !== NodeKind.FunctionNode){
            throw new Error("filter requires that the second parameter be a two argument function with the first postitional argument being an @ variable");
        }

        var lambda = funcNode.parameterList[1] as FunctionNode;
        if(lambda.parameterList[0].nodeType !== NodeKind.ArgumentNode){
            throw new Error("filter requires that the second parameter be a two argument function with the first postitional argument being an @ variable");
        }
        let arrayNode = funcNode.parameterList[0];
        let lambdaArgumetnNode = lambda.parameterList[0] as ArgumentNode;
        let lambdaExpressionNode = lambda.parameterList[1];
        return {array:arrayNode, lambdaArgument: lambdaArgumetnNode, lambdaExpression:lambdaExpressionNode};
    }


}




export class ArrayMap implements FunctionDefinition{

    name:string = "Map";

    compileSync(compiler: ExpressionCompiler, funcNode: FunctionNode): (args: Arguments) => any {
        let {array, lambdaArgument, lambdaExpression} = this._decomposeNodes(funcNode);
        let arr = compiler.compile(array);
        var expr = compiler.compile(lambdaExpression);
        return(args:Arguments)=>{
            let theArray = arr(args) as any[];
            return theArray.map(item=>{
                let copy = this._cloneArguments(args);
                copy.args.set(lambdaArgument.name, item);
                return expr(copy);
            });
        };
    }

    compileAsync(compiler: AsyncExpressionCompiler, funcNode:FunctionNode): (args: Arguments) => Promise<any> {
        let {array, lambdaArgument, lambdaExpression} = this._decomposeNodes(funcNode);
        let arr = compiler.compile(array);
        var expr = compiler.compile(lambdaExpression);
        return (args:Arguments)=>{
            return arr(args).then(theArray=>{
                var copies = (theArray as any[]).map(e=>{
                    var c = this._cloneArguments(args);
                    c.args.set(lambdaArgument.name, e);
                    return {element:e, localArgs:c};
                });
                var promises = copies.map(ee=>{
                    return expr(ee.localArgs);
                });
                return Promise.all(promises);
            });
        }
    }

    public _cloneArguments(args:Arguments) : Arguments{
        let map = new Map<string,any>();
        for(let k of Array.from(args.args.keys()))
        {
            map.set(k, args.args.get(k));
        }
        return {context: args.context, args:map};

    }
    public _decomposeNodes(funcNode:FunctionNode) : {array:LunaCodeNode, lambdaArgument:ArgumentNode, lambdaExpression: LunaCodeNode }{
        if(funcNode.parameterList.length !== 2 || !funcNode.parameterList[1]){
            throw new Error("filter requires two parametrs the first is an array, the second is a conditional expression");
        }
        if(funcNode.parameterList[1].nodeType !== NodeKind.FunctionNode){
            throw new Error("filter requires that the second parameter be a two argument function with the first postitional argument being an @ variable");
        }

        var lambda = funcNode.parameterList[1] as FunctionNode;
        if(lambda.parameterList[0].nodeType !== NodeKind.ArgumentNode){
            throw new Error("filter requires that the second parameter be a two argument function with the first postitional argument being an @ variable");
        }
        let arrayNode = funcNode.parameterList[0];
        let lambdaArgumetnNode = lambda.parameterList[0] as ArgumentNode;
        let lambdaExpressionNode = lambda.parameterList[1];
        return {array:arrayNode, lambdaArgument: lambdaArgumetnNode, lambdaExpression:lambdaExpressionNode};
    }


}


export class ArrayReduce implements FunctionDefinition{

    name:string = "Reduce";

    compileSync(compiler: ExpressionCompiler, funcNode: FunctionNode): (args: Arguments) => any {
        let {array, accumulatorArg, valueArg, lambdaExpression} = this._decomposeNodes(funcNode);
        let arr = compiler.compile(array);
        var expr = compiler.compile(lambdaExpression);
        return(args:Arguments)=>{
            let theArray = arr(args) as any[];
            let result = null;
            for(let i =0; i< theArray.length; i++){
                let copy = this._cloneArguments(args);
                copy.args.set(accumulatorArg.name, result);
                copy.args.set(accumulatorArg.name, theArray[i]);
                result = expr(copy);
            }
            return result;
        };
    }

    compileAsync(compiler: AsyncExpressionCompiler, funcNode:FunctionNode): (args: Arguments) => Promise<any> {
        let {array, accumulatorArg, valueArg, lambdaExpression} = this._decomposeNodes(funcNode);
        let arr = compiler.compile(array);
        var expr = compiler.compile(lambdaExpression);
        throw new Error("Jeff cant figure out how to reduce in async");
        // return (args:Arguments)=>{
        //     return arr(args).then(theArray=>{
        //         let copies = (theArray as []).map(e=>{
        //             var c = this._cloneArguments(args);
        //             c.args.set(lambdaArgument.name, e);
        //             return {element:e, localArgs:c};
        //         });
        //         var promises = copies.map(ee=>{
        //             return expr(ee.localArgs);
        //         });
        //         return Promise.all(promises).then(values=> evaluations.filter(qq=>qq.evaluated).map(qq=>qq.item));
        //     });
        // }
    }

    public _cloneArguments(args:Arguments) : Arguments{
        let map = new Map<string,any>();
        for(let k of Array.from(args.args.keys()))
        {
            map.set(k, args.args.get(k));
        }
        return {context: args.context, args:map};

    }
    public _decomposeNodes(funcNode:FunctionNode) : {array:LunaCodeNode, accumulatorArg:ArgumentNode, valueArg :ArgumentNode, lambdaExpression: LunaCodeNode }{
        if(funcNode.parameterList.length !== 2 || !funcNode.parameterList[1]){
            throw new Error("filter requires two parametrs the first is an array, the second is a conditional expression");
        }
        if(funcNode.parameterList[1].nodeType !== NodeKind.FunctionNode){
            throw new Error("filter requires that the second parameter be a two argument function with the first postitional argument being an @ variable");
        }

        var lambda = funcNode.parameterList[1] as FunctionNode;
        if(lambda.parameterList[0].nodeType !== NodeKind.ArgumentNode){
            throw new Error("filter requires that the second parameter be a two argument function with the first postitional argument being an @ variable");
        }
        let arrayNode = funcNode.parameterList[0];
        let accumulatorArg= lambda.parameterList[0] as ArgumentNode;
        let valueArg = lambda.parameterList[1] as ArgumentNode;
        let lambdaExpressionNode = lambda.parameterList[2];
        return {array:arrayNode, accumulatorArg: accumulatorArg, valueArg:valueArg, lambdaExpression:lambdaExpressionNode};
    }


}


export class StringConcat extends SimpleFunctionDefinitionBase {
    constructor(){
        super();
    }
    name: string = "CONCAT";
    invoke(a: Arguments, args: (arg: Arguments) => any[]) {
        let parts = args(a);
        let str = "";
        for(let i = 0; i< parts.length; i++){
            str += parts[i];
        }
        return str;
    }

}

export class StringLen extends SimpleFunctionDefinitionBase {
    constructor(){
        super();
    }
    name: string = "LEN";
    invoke(a: Arguments, args: (arg: Arguments) => any[]) {
        if (args(a) == null || args(a)[0] == null) return 0;
        return args(a)[0].length;
    }

}


export class StringLower extends SimpleFunctionDefinitionBase {
    constructor(){
        super();
    }
    name: string = "LOWER";
    invoke(a: Arguments, args: (arg: Arguments) => any[]) {
        return args(a)[0].toLowerCase();
    }

}

export class StringUpper extends SimpleFunctionDefinitionBase {
    constructor(){
        super();
    }
    name: string = "Upper";
    invoke(a: Arguments, args: (arg: Arguments) => any[]) {
        return args(a)[0].toUpperCase();
    }

}


export class StringTrimLeft extends SimpleFunctionDefinitionBase {
    constructor(){
        super();
    }
    public rx=/\s+$/;
    name: string = "LTRIM";
    invoke(a: Arguments, args: (arg: Arguments) => any[]) {
        let str = args(a)[0];
        return str.replace(this.rx, "");
    }

}

export class StringTrim extends SimpleFunctionDefinitionBase {
    constructor() {
        super();
    }
    public rx = /\s+$/;
    name: string = "TRIM";
    invoke(a: Arguments, args: (arg: Arguments) => any[]) {
        let str = args(a)[0];
        return (str as string).trim();
    }

}

export class StringTrimRight extends SimpleFunctionDefinitionBase {
    constructor() {
        super();
    }
    public rx = /\s+$/;
    name: string = "RTRIM";
    invoke(a: Arguments, args: (arg: Arguments) => any[]) {
        let str = args(a)[0];
        return str.replace(this.rx, "");
    }

}


export class StringSubstring extends SimpleFunctionDefinitionBase {
    constructor(){
        super();
    }
    name: string = "SUBSTRING";
    invoke(a: Arguments, args: (arg: Arguments) => any[]) {
        let parts = args(a);
        let s:string = parts[0];
        return s.substr(parts[1], parts[2]);
    }

}

export class BitwiseAND extends SimpleFunctionDefinitionBase {
    constructor() {
        super();
    }
    name: string = "BITWISEAND";
    invoke(a: Arguments, args: (arg: Arguments) => any[]) {

        let parts = args(a).map(x => parseInt(x));
        let result = parts[0];
        for (let i = 1; i < parts.length; i++) {
            result = result & parts[i];
        }
        return result;
    }
}

export class BitwiseOR extends SimpleFunctionDefinitionBase {
    constructor() {
        super();
    }
    name: string = "BITWISEOR";
    invoke(a: Arguments, args: (arg: Arguments) => any[]) {

        let parts = args(a).map(x => parseInt(x));
        let result = parts[0];
        for (let i = 1; i < parts.length; i++) {
            result = result | parts[i];
        }
        return result;
    }
}
export class BitwiseXOR extends SimpleFunctionDefinitionBase {
    constructor() {
        super();
    }
    name: string = "BITWISEXOR";
    invoke(a: Arguments, args: (arg: Arguments) => any[]) {

        let parts = args(a).map(x => parseInt(x));
        let result = parts[0];
        for (let i = 1; i < parts.length; i++) {
            result = result ^ parts[i];
        }
        return result;
    }
}
